import React from 'react';
import enhance from './enhance';

export const DesignOptionsDescription = ({ designPackage, designOptions }) => {
  return (
    <div>
      {designOptions.map((option, index) => {
        return designPackage[option] ? (
          <span key={option} data-test="designOption">
            <span style={{ fontWeight: 'bold' }}>
              {designPackage[option].id}
            </span>{' '}
            - {designPackage[option].description}
            {index !== designOptions.length - 1 && ', '}
          </span>
        ) : null;
      })}
    </div>
  );
};

export default enhance(DesignOptionsDescription);
